/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Browse_AllInputs */

const en_directory_hubs_browse_all = /** @type {(inputs: Directory_Hubs_Browse_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse all`)
};

const zh_directory_hubs_browse_all = /** @type {(inputs: Directory_Hubs_Browse_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览全部`)
};

/**
* | output |
* | --- |
* | "Browse all" |
*
* @param {Directory_Hubs_Browse_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_browse_all = /** @type {((inputs?: Directory_Hubs_Browse_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Browse_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_browse_all(inputs)
	return zh_directory_hubs_browse_all(inputs)
});
export { directory_hubs_browse_all as "directory.hubs.browse_all" }